'use client';

import { Suspense } from 'react';

import { useParams } from 'next/navigation';

import { LanguageSwitcher } from '@/app/i18n/switcher';

export default function LangSwitcher() {
  const queryParams = useParams<{ lang: string }>();
  const lang = queryParams?.['lang'];

  return lang ? (
    <Suspense>
      <LanguageSwitcher className="text-base" />
    </Suspense>
  ) : null;
}
